import cn from 'classnames/bind';
import React, { useCallback, useState } from 'react';
import styles from './styles.styl';
import { Button } from '@consta/uikit/Button';
import { useMediaQuery } from 'react-responsive';
import { Text } from '@consta/uikit/Text';
import { IconClose } from '@consta/uikit/IconClose';
import { IconBackward } from '@consta/uikit/IconBackward';
import { IconPlay } from '@consta/uikit/IconPlay';
import { IInputsArrayType, IInputsModelType } from 'src/utils/type';

const cx = cn.bind(styles);

export interface IAnimationModelsProps {
  className?: string;
  setIsAnimationModal: React.Dispatch<React.SetStateAction<boolean>>;
  setIsRunningModal: React.Dispatch<React.SetStateAction<boolean>>;
  outputsValue: IInputsArrayType[];
  inputsData: IInputsModelType;
  cloudClient: any;
  nameModal: string;
}

const AnimationModels: React.FC<IAnimationModelsProps> = ({
  className,
  setIsAnimationModal,
  setIsRunningModal,
  outputsValue,
  cloudClient,
  nameModal,
  inputsData,
}) => {
  const isMobile = useMediaQuery({ maxWidth: 460 });

  const [dataAnimtion, setDataAnimation] = useState(null);

  const [isLoadinRun, setIsLoadingRun] = useState(false);

  const vh = window.innerHeight * 0.01;

  document.documentElement.style.setProperty('--vh', `${vh}px`);

  const runAnimation = useCallback(() => {
    setIsLoadingRun(true);
    cloudClient
      .startAnimation(inputsData, 'animation-container')
      .then((animation: any) => {
        setDataAnimation(animation);
        setIsLoadingRun(false);
        return animation.waitForCompletion();
      })
      .catch((error: any) => {
        setIsLoadingRun(false);
        console.error(error);
      });
  }, [cloudClient, inputsData]);

  const handleBack = useCallback(() => {
    setIsRunningModal(false);
    setIsAnimationModal(false);
    dataAnimtion && dataAnimtion?.stop();
  }, [dataAnimtion, setIsAnimationModal, setIsRunningModal]);

  return (
    <div className={cx('AnimationModels', className)}>
      <div className={cx('AnimationModels__title')}>
        {isMobile && (
          <Button
            className={cx('AnimationModels__buttonCloseMobile')}
            iconSize="s"
            view="clear"
            onlyIcon
            iconLeft={IconBackward}
            onClick={handleBack}
          />
        )}
        <Text className={cx('AnimationModels__data')} weight="semibold">
          {`Результаты расчета ${nameModal}`}
        </Text>
        {!isMobile && (
          <Button
            className={cx('AnimationModels__buttonClose')}
            iconSize="s"
            view="clear"
            onlyIcon
            iconLeft={IconClose}
            onClick={handleBack}
          />
        )}
      </div>
      <div className={cx('AnimationModels__content')}>
        <div
          id="animation-container"
          className={cx('AnimationModels__animContainer')}
        />
        <Button
          onClick={runAnimation}
          size="s"
          label={'Запустить'}
          iconRight={IconPlay}
          view="secondary"
          className={cx('AnimationModels__buttonRun')}
          loading={isLoadinRun}
        />
        <div className={cx('AnimationModels__output')}>
          {outputsValue.map((item, index) => (
            <div key={index}>
              <Text
                className={cx('AnimationModels__name')}
                display="inlineBlock"
                view="secondary"
                size="s"
              >
                {`${item.name}:`}
              </Text>
              <Text size="s" display="inlineBlock">
                {item.value}
              </Text>
            </div>
          ))}
        </div>
      </div>
      <div className={cx('AnimationModels__save')}>
        <Button
          onClick={() => {
            setIsAnimationModal(false);
            dataAnimtion && dataAnimtion?.stop();
          }}
          size="s"
          label={'Назад'}
          view="ghost"
          className={cx('AnimationModels__buttonSave', 'AnimationModels__back')}
        />
        <Button
          onClick={handleBack}
          size="s"
          label={'Закрыть'}
          className={cx('AnimationModels__buttonSave')}
        />
      </div>
    </div>
  );
};

export default AnimationModels;
